<template>
  <div
    class="result-item-group d-flex align-items-center justify-content-between mb-3"
  >
    <div class="d-flex align-items-center gap-2">
      <div
        class="result-item-icon bg-warning d-flex align-items-center justify-content-center rounded-circle"
      >
        <span class="fw-400 fs-14 lh-18 text-white">
          {{ getInitialName(item.nama) }}
        </span>
      </div>
      <div class="d-flex flex-column fw-500">
        <span class="color-neutral-600">{{ item.no_lab }}</span>
        <span class="color-neutral-900">{{ item.nama }}</span>
      </div>
    </div>
    <img src="@/assets/icon/arrow-right-outline.svg" alt="Icon" />
  </div>
  <div
    class="bg-neutral-200 result-item-info d-flex align-items-center justify-content-between fw-400 fs-11 lh-22"
  >
    <span class="color-neutral-600">Cabang {{ item.nama_cabang }}</span>
    <span class="color-neutral-600">{{ formatDate(item.tgl) }}</span>
  </div>
  <hr class="divider-rating" />
  <div
    v-if="item.survei != null"
    class="d-flex align-items-center justify-content-center gap-1"
  >
    <i
      v-for="star in 5"
      :key="star"
      class="ri-star-fill fs-18"
      :class="star <= item.survei ? 'star-active' : 'star-inactive'"
    ></i>
  </div>
  <div v-else class="d-flex justify-content-center" @click.prevent.stop>
    <button
      class="btn btn-primary btn-sm w-100 fw-600 fs-12"
      @click="goToSurvei"
    >
      Beri Rating
    </button>
  </div>
</template>

<script>
import { getInitialName, formatDate } from '@/core/helper'
import { useRouter } from 'vue-router'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const router = useRouter()

    const goToSurvei = () => {
      // Clean up Bootstrap modal backdrop triggered by parent data-bs-toggle
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
      document
        .querySelectorAll('.modal.show')
        .forEach(el => el.classList.remove('show'))
      document.body.classList.remove('modal-open')
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('padding-right')

      router.push({
        name: 'SurveiKepuasan',
        params: {
          id_cabang: props.item.cabang,
          no_lab: props.item.no_lab
        },
        query: {
          uuid: props.item.uuid
        }
      })
    }

    return {
      formatDate,
      getInitialName,
      goToSurvei
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  &-item {
    &-icon {
      width: 36px;
      height: 36px;
    }

    &-info {
      padding: 8px;
      border-radius: 11px;
    }
  }
}

.divider-rating {
  border: none;
  border-top: 2px solid var(--bs-primary);
  margin: 10px 0;
  opacity: 0.3;
}

.star-active {
  color: #f59e0b;
}

.star-inactive {
  color: #d1d5db;
}
</style>
